import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';

interface RedirectTokens {
  idToken: string | null;
  refreshToken: string | null;
  state: string | null;
}

@Component({
  selector: 'app-redirect-echo',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './redirect-echo.component.html',
  styleUrl: './redirect-echo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class RedirectEchoComponent {
  readonly rawHash = signal<string | null>(null);
  readonly tokens = signal<RedirectTokens | null>(null);
  readonly copyFeedback = signal<string | null>(null);

  constructor() {
    this.parseHash();
  }

  private parseHash() {
    if (typeof window === 'undefined') {
      return;
    }
    const rawHash = window.location.hash.startsWith('#')
      ? window.location.hash.slice(1)
      : window.location.hash;
    if (!rawHash) {
      this.rawHash.set(null);
      this.tokens.set(null);
      return;
    }
    this.rawHash.set(rawHash);
    const params = new URLSearchParams(rawHash);
    this.tokens.set({
      idToken: params.get('idToken'),
      refreshToken: params.get('refreshToken'),
      state: params.get('state')
    });
  }

  async copyToClipboard() {
    const tokens = this.tokens();
    if (!tokens) {
      return;
    }
    const payload = JSON.stringify(tokens, null, 2);
    try {
      await navigator.clipboard.writeText(payload);
      this.copyFeedback.set('Tokens copied to clipboard.');
      setTimeout(() => this.copyFeedback.set(null), 3000);
    } catch (error) {
      console.warn('Failed to copy tokens', error);
      this.copyFeedback.set('Copy failed. Select the text manually instead.');
      setTimeout(() => this.copyFeedback.set(null), 3000);
    }
  }
}
